import { render, staticRenderFns } from "./PromotedBlock.vue?vue&type=template&id=4656a7d0&"
import script from "./PromotedBlock.vue?vue&type=script&lang=js&"
export * from "./PromotedBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiSwiperCarousel: require('/app/components/UI/UiSwiperCarousel.vue').default})
